/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ServiceState = 'KNOWN' | 'DISABLED' | 'ENABLED';

export const ServiceState = {

    KNOWN: 'KNOWN' as ServiceState,

    DISABLED: 'DISABLED' as ServiceState,

    ENABLED: 'ENABLED' as ServiceState
};

